module.exports = __webpack_public_path__ + "img/img-play8-fish-d.0c7697a0.png";